import React from 'react';
import Icon from "./Icons";


const ServiceCard = ({ title, description, image, width, height, altText, icon }) => {
  return (
    <article className="service-card">
      <div className="service-image-wrap">
        <img
          src={image}
          alt={altText}
          className="service-image"
          width={width}
          height={height}
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="service-card-content">
        <span className="service-icon" aria-hidden="true">
          <Icon name={icon} />
        </span>
        <h3 className="service-title">{title}</h3>
        <p className="service-description">{description}</p>
      </div>
    </article>
  );
}

export default ServiceCard;
